__turbopack_context__.v({
  "action_btn": "SubmitResult-module-scss-module__Xwshta__action_btn",
  "actions": "SubmitResult-module-scss-module__Xwshta__actions",
  "articles": "SubmitResult-module-scss-module__Xwshta__articles",
  "content_area": "SubmitResult-module-scss-module__Xwshta__content_area",
  "description": "SubmitResult-module-scss-module__Xwshta__description",
  "message_area": "SubmitResult-module-scss-module__Xwshta__message_area",
  "root": "SubmitResult-module-scss-module__Xwshta__root",
  "root_inline": "SubmitResult-module-scss-module__Xwshta__root_inline",
  "root_page": "SubmitResult-module-scss-module__Xwshta__root_page",
  "root_popup": "SubmitResult-module-scss-module__Xwshta__root_popup",
  "title": "SubmitResult-module-scss-module__Xwshta__title",
});
